// extracted by mini-css-extract-plugin
export default {"selectWrapper":"RoleList_selectWrapper__FxVs8","list":"RoleList_list__qVaic","active":"RoleList_active__frW1v","item":"RoleList_item__du+y7"};